export const environment = {
  production: false,
  name: "Trail Fusion - Staging",
  verificationRedirectUrl: "https://staging-admin-portal.trailfusion.net",
  baseUrl: "https://staging-admin-portal.trailfusion.net",
  apiUrl:
    "https://us-central1-staging-admin-portal-2999c.cloudfunctions.net/api/admin",
  apiUrlNewCall:
    "https://us-central1-staging-admin-portal-2999c.cloudfunctions.net/api/",
  apiUrlCache:
    "https://us-central1-staging-admin-portal-2999c.cloudfunctions.net/api/cache",
  apiUrlMail:
    "https://us-central1-staging-admin-portal-2999c.cloudfunctions.net/api/mail",
  parentPortalUrl: "https://staging-parent-portal.trailfusion.net",
  firebase: {
    apiKey: "AIzaSyAZ-mRYBbRECRgGqWWuMDgsACp1-hBcbUU",
    authDomain: "staging-admin-portal-2999c.firebaseapp.com",
    projectId: "staging-admin-portal-2999c",
    storageBucket: "staging-admin-portal-2999c.firebasestorage.app",
    messagingSenderId: "181742384325",
    appId: "1:181742384325:web:a0cd1f73a9e07e167eecac",
    measurementId: "G-BBTH39RRE1",
  },
  ipifyUrl: "https://api.ipify.org/?format=json",
  ipinfoUrl: "https://ipinfo.io/",
  ipinfoToken: "?token=abe7cb4c38b788",
  getClientIPAddressByIpify: "getClientIPAddressByIpify",
};
